import { render, staticRenderFns } from "./LiveCall.vue?vue&type=template&id=3bb320e5&"
import script from "./LiveCall.vue?vue&type=script&lang=js&"
export * from "./LiveCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports